import React, { useRef, useMemo } from 'react';
import cn from 'classnames';
import { Button, Form, Grid, TextArea, View } from 'src/components/common';
import './styles.scss';
import { IRootState } from 'src/redux/rootReducer';
import { connect } from 'react-redux';
import { ErrorService, Yup } from 'src/services';
import { Formik, FormikProps } from 'formik';
import { useEffect } from 'react';
import { CreateTaskPayload, TaskInfo, TaskModalTypes } from 'src/redux/task/types';
import { addTaskAsync, updateTaskAsync } from 'src/redux/task/actions';
import { CustomModal } from 'src/components/Modal';

const TaskSchema = Yup.object().shape({
  name: Yup.string().max(255, ErrorService.MESSAGES.descriptionMaxLength).required(),
});

const TaskModal: React.FC<Props> = ({ loading, data, openModalType, onClose, status, onUpdateTask, onAddTask }) => {
  const formRef = useRef<FormikProps<TaskInfo>>(null);

  useEffect(() => {}, [data]);

  const handleSubmit = (value: TaskInfo) => {
    const payload: CreateTaskPayload = {
      name: value.name,
      status: 'active',
    };

    if (openModalType === TaskModalTypes.EDIT) onUpdateTask({ id: value.id, body: payload });
    if (openModalType === TaskModalTypes.ADD) onAddTask(payload);
  };

  const renderTitle = () => {
    switch (openModalType) {
      case TaskModalTypes.EDIT:
        return <h3>Edit Task</h3>;
      case TaskModalTypes.ADD:
        return <h3>Add Task</h3>;
    }
  };

  const renderBody = useMemo(() => {
    return (
      <Formik
        key={`formik-type-${data.name}-${openModalType}`}
        initialValues={data}
        onSubmit={handleSubmit}
        validationSchema={TaskSchema}
        innerRef={formRef}>
        {({ handleSubmit, errors, touched, getFieldProps, setFieldValue, setFieldTouched }) => (
          <Form preventDefault autoComplete="off" className="ctn-uam__form">
            <Grid.Wrap>
              <Grid.Item variant="is-full">
                <TextArea
                  label="Description *"
                  placeholder="Description"
                  errorMessage={touched.name ? errors.name : ''}
                  {...getFieldProps('name')}
                />
              </Grid.Item>
            </Grid.Wrap>
            <View className={cn('ctn-task-modal__footer')}>
              <View flexGrow={1} justify={'flex-end'} isRow className={'mt-32'}>
                <Button label={'CANCEL'} onClick={onClose} className={cn('mr-5')} variant={'outline'} type={'button'} />
                <Button type={'button'} onClick={() => handleSubmit()} isLoading={loading}>
                  {openModalType === TaskModalTypes.EDIT ? 'UPDATE' : 'ADD'}
                </Button>
              </View>
            </View>
          </Form>
        )}
      </Formik>
    );
    // eslint-disable-next-line
  }, [data, loading, openModalType]);

  return (
    <CustomModal
      openModalType={openModalType}
      header={renderTitle()}
      body={renderBody}
      containerClassName={'ctn-task-modal__custom'}
    />
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    onClose?: () => void;
  };

const mapStateToProps = (state: IRootState) => ({
  data: state.task.selectedTask,
  loading: state.task.isLoading,
  status: state.content.status,
  openModalType: state.task.openModalType,
});

const mapDispatchToProps = {
  onUpdateTask: updateTaskAsync.request,
  onAddTask: addTaskAsync.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskModal);
